export default __webpack_public_path__ + "static/media/looplogo.ff9fcd4a.svg";